<mat-form-field class="me-3">
  <input
    type="text"
    placeholder="Search For a Unit"
    matInput
    name="unitsControl"
    [matAutocomplete]="auto"
    [formControl]="unitsControl"
    [(ngModel)]="selectedUnit"
    (blur)="checkSelection()"
  />
  <mat-autocomplete #auto="matAutocomplete">
    @for (unit of filteredUnits; track unit.id) {
      <mat-option [value]="unit.id">
        {{ unit.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
<mat-form-field class="col-4">
  <input
    matInput
    type="text"
    placeholder="Filter by Roles (comma separated)"
    [(ngModel)]="rolesToSearch"
  />
</mat-form-field>
<mat-form-field class="me-3">
  <mat-label>Pick a ReportType</mat-label>
  <mat-select name="reportTypes" [(ngModel)]="selectedType">
    @for (type of reportTypes; track type) {
      <mat-option [value]="type.value">
        {{ type.label }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
<span class="me-3">
  <mat-checkbox
    [checked]="includeInactive"
    (change)="includeInactive = !includeInactive"
  />
  <span>Include Inactive Users</span>
</span>
<button
  type="button"
  mat-raised-button
  color="accent"
  [disabled]="!selectedType || !selectedUnit"
  (click)="getUnitActiveUsers()"
>
  Get Active Users Report
</button>
<ngx-loading [show]="loading" />
